import React from 'react';

const FriendsInv = ({ triggerToast, refss, setRewards, rewards, setClickCount }) => {

  const claimReward = async (rewardId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/referrals/claim`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reward_id: rewardId }),
      });

      const data = await response.json();
      if (response.ok) {
        triggerToast('Вы получили награду!');
        setClickCount(Number(data.clickCount));
        setRewards((prev) => prev.map((reward) => (
          reward.id === rewardId ? { ...reward, claimed: true } : reward
        )));
      } else {
      }
    } catch (error) {
      console.error('Error claiming reward:', error);
    }
  };

  return (
    <div className="container_">
      <h1>Сундук реферальных наград</h1>
      <div className="chest-image">
        <img src="/assets/imgur/qhwipuV.jpg" alt="Chest" />
      </div>

      {/* Полоса прогресса */}
      <div className="progress-wrapper">
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${Math.min((refss / 100) * 100, 100)}%` }}
          />
        </div>
        <div className="progress-labels">
          {[0, 20, 40, 60, 80, 100].map((mark) => (
            <span key={mark} className="progress-mark">
              {mark}
            </span>
          ))}
        </div>
      </div>
<div className="rewards-section">
  {rewards.map((reward) => (
    <div key={reward.id} className="reward-item">
      <div className="ticket">
        <div className="ticket-info">
          <span className="reward-refs"> {refss >= reward.required_refs 
  ? 'Вы можете забрать приз!' 
  : `ПРИГЛАСИ ЕЩЁ: ${reward.required_refs - refss} ДРУЗЕЙ`}</span>
          <button
            className="claim-button"
            onClick={() => claimReward(reward.id)}
            disabled={reward.claimed || refss < reward.required_refs}
          >
            {reward.claimed ? 'ПОЛУЧЕНО' : refss >= reward.required_refs ? 'ЗАБРАТЬ' : 'НЕДОСТУПНО'}
          </button>
          <span className="reward-named">{refss >= reward.required_refs 
  ? `${reward.reward} КЛИКОВ` 
  : `И ЗАБЕРИ ${reward.reward} КЛИКОВ`}</span>
        </div>
      </div>
    </div>
  ))}
</div>


    </div>
  );
};

export default FriendsInv;
